module.exports = __webpack_public_path__ + "static/media/HeatherLawrence.44ba261f.jpg";